import axios from "axios";

// let testHost = 'http://localhost:10202'
// let productHost = 'https://course.yepaofu.com/yifahuo'
// let prod = false
// let host = prod ? productHost: testHost
let host = '/api/yifahuo'
let sessionKey = ''
//超时时间 90s
axios.defaults.timeout = 1000 * 90

const get = (url, params, callback) => {
    let uri = url + buildParams(params)
    return doRequest(uri, 'GET', null, callback)
}

const post = (url, params, data, callback) => {
    let uri = url + buildParams(params)
    return doRequest(uri, 'POST', data, callback)
}

/**
 * 封装请求方法
 * @param {string} url
 * @param {string} method
 * @param {object} data
 * @param {object} success，fail，complete callback
 */
function doRequest(url, method, data, callback) {

    callback = callback || {}
    let headers = {}

    if (sessionKey) {
        headers.sessionKey = sessionKey
    }

    let {success, fail, complete} = callback

    axios({
        url: host + '/' + url,
        method,
        headers,
        data
    }).then( res => {
        let data = res.data
        if(data.error === 401) {
            // 缺少sessionKey 重新执行一次登录
            console.log('缺少sessionKey')
            return false
        }

        if(success) {
            success(res.data)
        }

        if (complete) {
            complete()
        }

    } ).catch(error => {

        if(fail) {
            if (error && error.message.indexOf('timeout') > -1) {
                const message = '网络超时：' + error.message
                error.message = message
                fail(error)
            } else {
                fail(error)
            }
        }

        if (complete) {
            complete()
        }
    })

}

function doRequestPromise(url, method, data, complete, fullData) {
    return new Promise( (resolve, reject) => {
        doRequest(url, method, data, {
            success(data) {
                if (data.error == 200) {
                    if (fullData) {
                        resolve(data)
                    } else{
                        resolve(data.data)
                    }
                } else {
                    reject(data)
                }
            },
            fail(error) {
                reject(error)
            },
            complete() {
                if (complete) {
                    complete()
                }
            }
        })
    })
}

const getPromise = (url, params, complete, fullData) => {
    let uri = url + buildParams(params)
    return doRequestPromise(uri, 'GET', null, complete, fullData)
}

const postPromise = (url, params, data, complete, fullData) => {
    let uri = url + buildParams(params)
    return doRequestPromise(uri, 'POST', data, complete, fullData)
}

function buildParams(obj) {
    let result = ''
    let item

    for (item in obj) {
        if(obj[item] && String(obj[item])) {
            result += `&${item}=${obj[item]}`
        }
    }

    if (result) {
        result ='?'+ result.slice(1)
    }

    return result
}

const setSessionKey = (sk) => {
    sessionKey = sk
}

const sessionKeyExist = () => {
    return sessionKey && sessionKey.length > 0
}

export default {
    get,
    getPromise,
    post,
    postPromise,
    setSessionKey,
    buildParams,
    sessionKeyExist,
}


// WEBPACK FOOTER //
// ./src/request/request.js